import React, { useState, useEffect } from "react";
import { Grid, Menu } from "semantic-ui-react";
import { Link, useLocation } from "react-router-dom";
import {
  IoIosArrowDroprightCircle,
  IoIosArrowDropupCircle,
} from "react-icons/io";
import { userData } from "../pages/store/userData";
import "./SideBarComp.css";

const SideBarComp = () => {
  const [expandState, setExpandState] = useState({});
  const location = useLocation();

  const userDetail = userData();

  useEffect(() => {
    const activeParentMenu = location.pathname.split("/")[1];
    if (activeParentMenu) {
      setExpandState((prevState) => ({
        ...prevState,
        [activeParentMenu]: true,
      }));
    }
  }, [location.pathname]);

  const handleParentMenuClick = (parentMenu) => {
    setExpandState((prevState) => ({
      ...prevState,
      [parentMenu]: !prevState[parentMenu],
    }));
  };

  const isChildMenuActive = (childMenu) => location.pathname.includes(childMenu);

  const renderSubMenuItems = (subMenuItems = []) =>
    subMenuItems.map((subMenuItem) => (
      <Menu.Item
        className="sidebar-child"
        key={subMenuItem.name}
        as={Link}
        to={subMenuItem.to}
        active={isChildMenuActive(subMenuItem.name)}
      >
        {subMenuItem.name}
      </Menu.Item>
    ));

  const renderParentMenuItem = (parentMenuItem) => {
    const { name, subMenuItems } = parentMenuItem;
    const isExpanded = expandState[name];
    const hasChildren = subMenuItems && subMenuItems.length > 0;

    if (!hasChildren) {
      return (
        <Menu.Item
          className="sidebar-parent"
          key={name}
          as={Link}
          to={parentMenuItem.to}
          active={isChildMenuActive(parentMenuItem.name)}
        >
          <span>{name}</span>
        </Menu.Item>
      );
    }

    return (
      <React.Fragment key={name}>
        <Menu.Item
          className="sidebar-parent with-children"
          onClick={() => handleParentMenuClick(name)}
          active={isExpanded}
        >
          <span>{name}</span>
          <span className="chevron">
            {isExpanded ? (
              <IoIosArrowDropupCircle />
            ) : (
              <IoIosArrowDroprightCircle />
            )}
          </span>
        </Menu.Item>
        {isExpanded && renderSubMenuItems(subMenuItems)}
      </React.Fragment>
    );
  };

  const menuData = [
    userDetail.dashboard == true && {
      name: "DASHBOARD",
      to: "/dashboard",
      subMenuItems: [],
    },
    userDetail.employee == true && {
      name: "EMPLOYEE",
      subMenuItems: [
        {
          name: "Create Employee",
          to: "/create-employee/null",
        },
        {
          name: "List Employee",
          to: "/list-employee",
        },
      ],
    },
    userDetail.companyEmployee == true && {
      name: "COMPANY EMPLOYEE",
      subMenuItems: [
        {
          name: "List Catogery",
          to: "/list-company-emp-catogery",
        },
        {
          name: "List Employee",
          to: "/list-company-employee/null",
        },
      ],
    },
    userDetail.contact == true && {
      name: "CONTACT",
      subMenuItems: [
        {
          name: "List Catogery",
          to: "/list-contact-catogery",
        },
        {
          name: "List Contacts",
          to: "/list-contact-details/null",
        },
      ],
    },
    userDetail.invoice == true && {
      name: "INVOICE",
      subMenuItems: [
        {
          name: "List Catogery",
          to: "/list-invoice-catogery",
        },
        {
          name: "Work Name List",
          to: "/list-invoice-workname",
        },
        {
          name: "List Invoice Item",
          to: "/list-invoice-item",
        },
        {
          name: "List Invoice",
          to: "list-invoice/null",
        },
      ],
    },
    userDetail.receiveMoney == true && {
      name: "RECEIVE MONEY",
      subMenuItems: [
        {
          name: "List Catogery",
          to: "/recive-money-catogery",
        },
        {
          name: "List Receive Money",
          to: "/list-recive-money/null",
        },
      ],
    },
    userDetail.spendMoney == true && {
      name: "SPEND MONEY",
      subMenuItems: [
        {
          name: "List Catogery",
          to: "/spend-money-catogery",
        },
        {
          name: "List Spend Money",
          to: "/list-spend-money/null",
        },
      ],
    },
    userDetail.purchaseDetail == true && {
      name: "PURCHASE DETAIL",
      subMenuItems: [
        {
          name: "Purchase Category List",
          to: "/purchase-category-list",
        },
        {
          name: "Purchase List",
          to: "/purchase-list/null",
        },
      ],
    },
    userDetail.dailyWork == true && {
      name: "DAILY WORK",
      subMenuItems: [
        {
          name: "Daily Work Category",
          to: "/daily-work-category",
        },
        {
          name: "Daily For Name List",
          to: "/list-dailywork-forname",
        },
        {
          name: "Daily Work List",
          to: "/daily-work-list/null",
        },
      ],
    },
    userDetail.createVisa == true && {
      name: "CREATE VISA",
      subMenuItems: [
        {
          name: "Visa Category List ",
          to: "/list-visa-category",
        },
        {
          name: "Visa List ",
          to: "/list-visa-all/null",
        },
      ],
    },
    userDetail.fleetMgnt == true && {
      name: "FLEET MANAGMENT ",
      subMenuItems: [
        {
          name: "Tour List ",
          to: "/tour-list",
        },
        {
          name: "Vehicle List ",
          to: "/vehile-list",
        },
      ],
    },
    userDetail.ticketImventory == true && {
      name: "TICKET INVENTORY",
      subMenuItems: [
        {
          name: "Attraction List",
          to: "/attractopn-caregory-list/null",
        },
        {
          name: "Ticket Type List",
          to: "/tickettype-caregory-list/null",
        },
        {
          name: "Ticket Data ",
          to: "/list-ticket-data-all/null",
        },
      ],
    },
    userDetail.ticketImventory == true && {
      name: "TICKET INVENTORY TWO",
      subMenuItems: [
        {
          name: "Attraction List",
          to: "/attractopn-caregory-list-two/null",
        },
        {
          name: "Ticket Type List",
          to: "/tickettype-caregory-list-two/null",
        },
        {
          name: "Ticket Data ",
          to: "/list-ticket-data-all-two/null",
        },
      ],
    },
    userDetail.dataEntry == true && {
      name: "DATA ENTRY",
      subMenuItems: [
        {
          name: "Data Entry Catogery",
          to: "/data-inv-catogery-list",
        },
        {
          name: "Data Entry List",
          to: "/data-inv-new-list/null",
        },
      ],
    },
    userDetail.dataEntryindia == true && {
      name: "DATA ENTRY INDIA",
      subMenuItems: [
        {
          name: "Data Entry Catogery",
          to: "/data-inv-catogery-india-list",
        },
        {
          name: "Data Entry List",
          to: "/data-inv-new-india-list/null",
        },
      ],
    },
    userDetail.dataEntryindia == true && {
      name: "DAILY ENTRY",
      subMenuItems: [
        {
          name: "Catogery List",
          to: "/daily-entry-catogery-list",
        },
        {
          name: "Company List",
          to: "/daily-entry-company-list",
        },
        {
          name: "Ticket Type List",
          to: "/daily-entry-ticket-type-list",
        },
        {
          name: "Recived Bank List",
          to: "/daily-entry-recived-bank-list",
        },
        {
          name: "Daily Entry List",
          to: "/daily-entry-data-list",
        },
      ],
    },
  ];

  return (
    <Grid.Column
      tablet={3}
      computer={3}
      only="tablet computer"
      id="sidebar"
      className="sidebar-shell"
    >
      <div className="sidebar-surface">
        <Menu vertical borderless fluid text className="sidebar-menu">
          {menuData.filter(Boolean).map((menuItem) => (
            <React.Fragment key={menuItem.name}>
              {renderParentMenuItem(menuItem)}
            </React.Fragment>
          ))}
        </Menu>
      </div>
    </Grid.Column>
  );
};

export default SideBarComp;
